import React from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../store/store";
import { Button, Dialog, DialogActions, Divider, Grid, Typography } from "@mui/material";
import Transition from "../common/Transition";
import { handleClearSinglePredictionResults, handleToggleSinglePredictionDialog } from "../../store/prediction-slice/prediction";
import { useTranslation } from "react-i18next";
import { Header } from "../common/Header";
import RedirectIconButton from '../common/RedirectIconButton';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';

const SinglePredictionResultDialog = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { singlePredictionResultDialogOpen, singlePredictionResult } = useAppSelector((state: RootState) => state.prediction);

    function handleClose() {
        dispatch(handleClearSinglePredictionResults());
        dispatch(handleToggleSinglePredictionDialog(false));
    }

    return(
        <React.Fragment>
            <Dialog
                open={singlePredictionResultDialogOpen}
                TransitionComponent={Transition}
                keepMounted
                onClose={(_, reason) => {
                    if(reason !== 'backdropClick') handleClose();
                }}
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                maxWidth="sm"
            >
                <Header 
                    title={t('SINGLE_PREDICTION_DIALOG_TITLE')} 
                    helperIcon={
                        <RedirectIconButton to={'/help/4'} className="helper-icon" >
                            <ContactSupportIcon />
                        </RedirectIconButton>
                    }
                />
                <Grid p={2}>
                    { !singlePredictionResult ? 
                        <Grid container>
                            <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
                                <Typography>{t('SINGLE_PREDICTION_DIALOG_NO_RESULT')}</Typography>
                            </Grid>
                        </Grid> :
                        <Grid container>
                            <Grid item xs={12}>
                                <Grid container display={"flex"} justifyContent={"space-between"}>
                                    <Grid item>{t('SINGLE_PREDICTION_RESULT_START_DATE')}</Grid>
                                    <Grid item>{singlePredictionResult?.startPredictDateTimeUTC ?? '---'}</Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container display={"flex"} justifyContent={"space-between"}>
                                    <Grid item>{t('SINGLE_PREDICTION_RESULT_END_DATE')}</Grid>
                                    <Grid item>{singlePredictionResult?.endPredictDateTimeUTC ?? '---'}</Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container display={"flex"} justifyContent={"space-between"}>
                                    <Grid item>{t('SINGLE_PREDICTION_RESULT_DURATION')}</Grid>
                                    <Grid item>{singlePredictionResult?.predictDuration ?? '---'}</Grid>
                                </Grid>
                            </Grid>
                            <Grid mt={2.5} item xs={12}>
                                {t('SINGLE_PREDICTION_RESULTS_LABEL')}
                            </Grid>
                            <Grid mt={.5} mb={2} item xs={12}><Divider /></Grid>
                            <Grid item xs={12} sx={{ height: '200px', overflowY: 'auto' }}>
                                { singlePredictionResult?.predictionResult?.map((el: string, index: number) => {
                                    return(
                                        <Grid key={index} item xs={12} pr={1}>
                                            <Grid container display={"flex"} justifyContent={"space-between"}>
                                                <Grid item sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row'}}>
                                                    <Typography>&nbsp;{el}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </Grid> 
                    }
                </Grid>
                <DialogActions>
                    <Button size="small" variant='contained' className="button-color"  onClick={handleClose}>{t('CLOSE_BUTTON')}</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default SinglePredictionResultDialog;